var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('dv-scroll-board',{key:_vm.refreshFlagKey,style:({width:_vm.width+'px',height:_vm.height+'px'}),attrs:{"config":_vm.config}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }